import type { UmbEntityModel } from '@umbraco-cms/backoffice/entity';
import type { UmbItemDataResolverConstructor } from '@umbraco-cms/backoffice/entity-item';
import type { UmbPickerModalData, UmbPickerModalValue } from '@umbraco-cms/backoffice/modal';
import { UmbModalToken } from '@umbraco-cms/backoffice/modal';

export interface UmbRestoreFromRecycleBinModalData {
	unique: string;
	entityType: string;
	recycleBinRepositoryAlias: string;
	itemRepositoryAlias: string;
	itemDataResolver?: UmbItemDataResolverConstructor;
	pickerModal: UmbModalToken<UmbPickerModalData<any>, UmbPickerModalValue> | string;
	destinationItemRepositoryAlias?: string;
	destinationItemDataResolver?: UmbItemDataResolverConstructor;
	destinationRootEntityType?: string;
}

export interface UmbRestoreFromRecycleBinModalValue {
	destination: UmbEntityModel | undefined;
}

export const UMB_RESTORE_FROM_RECYCLE_BIN_MODAL = new UmbModalToken<
	UmbRestoreFromRecycleBinModalData,
	UmbRestoreFromRecycleBinModalValue
>('Umb.Modal.RecycleBin.Restore', {
	modal: {
		type: 'sidebar',
		size: 'small',
	},
});
